import React from 'react';
import {SvgIcon, useTheme} from '@mui/material';
import type {FilledIconProps} from './types';

export const RoundBackgroundIcon: React.FC<FilledIconProps> = ({
  fillColor,
  fillColorCode,
  ...props
}) => {
  const {status} = useTheme();
  const themeFillColor =
    (fillColor ? status[fillColor] : undefined) ?? fillColorCode ?? 'none';
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="8" fill={themeFillColor} />
    </SvgIcon>
  );
};
